<template>
  <ul class="reset">
    <li class="product-variation-item" v-for="item of items" :key="item.objectID">
      <Variation
        :item="item"
        :show-number-input="false"
        :show-price-info="false"
        :show-estimated-ship-date="showEstimatedShipDate"
        :show-download-model-spec="true"
      />
    </li>
    <li class="mt-lg flex" v-if="!isLastPage">
      <slo-button class="mx-auto" fill="outline" @click="handleRefineNext(refineNext)">
        {{ 'View More Variations' | t }}
      </slo-button>
    </li>
    <li v-if="hasZurnAttribution()" class="mt-lg text-center c-gray-600" style="font-size: 12px;">
      {{ '† The brands and/or products names referenced herein may be subject to trademark rights of their respective owners. Use of the brands and names is for identification purposes only and does not imply affiliation with or endorsement by Sloan.' | t }}
    </li>
    <li v-if="hasRefined">
      <slot />
    </li>
  </ul>
</template>

<script>
import Variation from './Variation.vue';
import SloButton from '../../../lib/components/SloButton.vue';
import t from '../../main/i18n';

export default {
  components: {
    Variation,
    SloButton
  },
  props: {
    items: {type: Array},
    refineNext: {type: Function},
    isLastPage: {type: Boolean},
    showEstimatedShipDate: {type: Boolean, default: false}
  },
  data() {
    return {
      hasRefined: false
    };
  },
  filters: {
    t
  },
  methods: {
    handleRefineNext(cb) {
      if (!this.hasRefined) this.hasRefined = true;
      cb();
    },
    hasZurnAttribution() {
      return this.items.some(item =>
        Object.prototype.hasOwnProperty.call(item, 'variation_description')
          ? item.variation_description?.toLowerCase().includes('zurn')
          : false
      );
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../scss/system';

.product-variation-item {
  margin-top: 32px;
  padding-bottom: 32px;
  border-bottom: 1px solid $color-gray-400;

  :deep(.slo-price-info) {
    margin-bottom: 16px;
  }
}
</style>
